import { Form } from '@anytag/shared-atoms';
import { FilterAction } from '@anytag/shared-types';
import {
  PostReportFilter,
  DownloadPostReportsButton,
  PostReportFilterFormValues,
  PostReportSearchSchemaType
} from '../../../PostReport';

export interface MarketplaceReportFilterProps extends FilterAction<PostReportFilterFormValues> {
  campaignId: number;
  segmentState: PostReportSearchSchemaType['state'];
}
export const MarketplaceReportFilter = ({
  filter,
  setFilter,
  campaignId,
  segmentState
}: MarketplaceReportFilterProps) => (
  <PostReportFilter filter={filter} setFilter={setFilter}>
    <Form.Field className="flex-none">
      <DownloadPostReportsButton filter={filter} campaignId={campaignId} segmentState={segmentState} />
    </Form.Field>
  </PostReportFilter>
);
